import React from 'react';
import { WaveformVisualizer } from './WaveformVisualizer';
export function StudioSection() {
  return <section id="studio" className="py-24 bg-[#0F0F16] border-t border-white/5" data-id="element-136">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-137">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-138">
          <div data-id="element-139">
            <span className="text-[#8B5CF6] font-mono text-sm tracking-widest uppercase mb-2 block" data-id="element-140">
              About Us
            </span>
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-6" data-id="element-141">
              The Echecgamer Studio
            </h2>

            <div className="space-y-6 text-gray-400 leading-relaxed" data-id="element-142">
              <p data-id="element-143">
                Founded in Warsaw in 2024, Echecgamer began as a research
                project into neural audio synthesis. Today, we are a leading
                provider of AI voice technology for game developers, content
                creators, and enterprise applications across Europe.
              </p>
              <p data-id="element-144">
                Our studio combines traditional audio engineering expertise with
                cutting-edge machine learning models. We believe that AI
                shouldn't just mimic human speech—it should capture the emotion,
                intent, and subtlety of a true performance.
              </p>
              <p data-id="element-145">
                Every voice model in our library is ethically sourced, created
                in partnership with professional voice actors who receive
                royalties for their contributions to our{' '}
                <span className="text-white" data-id="element-146">Harmonic Forge™</span>.
              </p>
            </div>
          </div>

          <div className="relative" data-id="element-147">
            {/* Abstract Studio Graphic */}
            <div className="aspect-square md:aspect-video lg:aspect-square rounded-2xl bg-[#0A0A0F] border border-white/10 p-8 relative overflow-hidden flex items-center justify-center" data-id="element-148">
              <div className="absolute inset-0 bg-[url('https://grainy-gradients.vercel.app/noise.svg')] opacity-20" data-id="element-149"></div>

              {/* Concentric Circles */}
              <div className="absolute inset-0 flex items-center justify-center" data-id="element-150">
                <div className="w-[150%] h-[150%] border border-[#8B5CF6]/10 rounded-full animate-[spin_10s_linear_infinite]" data-id="element-151"></div>
                <div className="w-[100%] h-[100%] border border-[#8B5CF6]/20 rounded-full animate-[spin_15s_linear_infinite_reverse]" data-id="element-152"></div>
                <div className="w-[50%] h-[50%] border border-[#8B5CF6]/30 rounded-full" data-id="element-153"></div>
              </div>

              {/* Central Visualizer */}
              <div className="relative z-10 w-full max-w-[300px] space-y-4" data-id="element-154">
                <WaveformVisualizer height={60} bars={30} color="#8B5CF6" data-id="element-155" />
                <WaveformVisualizer height={40} bars={30} color="#00F0FF" className="opacity-50" data-id="element-156" />
                <WaveformVisualizer height={20} bars={30} color="#FF00AA" className="opacity-30" data-id="element-157" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}